import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "toast" }


export default /*@__PURE__*/_defineComponent({
  __name: 'Toast',
  props: {
    visible: { type: Boolean },
    title: {}
  },
  setup(__props: any) {





return (_ctx: any,_cache: any) => {
  return _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("p", null, _toDisplayString(__props.title || '提示'), 1)
  ], 512)), [
    [_vShow, __props.visible]
  ])
}
}

})